import { mentionToMarkerText } from '../markers';
import { Mention } from '../types';
import { isMentionChipElement, readMentionFromChipElement } from './dom-chip';
import {
  isUnresolvedMentionElement,
  readUnresolvedMentionText,
} from './unresolved-mention';

export interface SerializedEditorContent {
  text: string;
  mentions: Mention[];
}

export const serializeEditor = (root: HTMLElement): SerializedEditorContent => {
  const mentions: Mention[] = [];
  let text = '';

  root.childNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.nodeValue ?? '';
    } else if (isMentionChipElement(node)) {
      const mention = readMentionFromChipElement(node);
      mentions.push(mention);
      text += mentionToMarkerText(mention);
    } else if (isUnresolvedMentionElement(node)) {
      text += readUnresolvedMentionText(node);
    } else if (node instanceof HTMLElement) {
      text += node.tagName === 'BR' ? '\n' : (node.textContent ?? '');
    }
  });

  return { text: text.replace(/\u00a0/g, ' '), mentions };
};

export const isEditorEmpty = (root: HTMLElement): boolean =>
  root.textContent?.trim().length === 0 &&
  root.querySelectorAll('[data-mention-chip]').length === 0 &&
  root.querySelectorAll('[data-mention-unresolved]').length === 0;
